import { Head, Link } from '@inertiajs/react'

export default function Index() {
  return (
    <div className="font-sans">
      <Head title="HabitPoint · 习惯积分 — 设目标 · 拆步骤 · 完成得分 · 积分兑换" />

      {/* ============ 顶栏 ============ */}
      <header className="sticky top-0 z-30 bg-white/85 backdrop-blur border-b border-[#e7ebf2]">
        <div className="max-w-[1080px] mx-auto px-5 h-16 flex items-center gap-3">
          <a href="#" className="font-extrabold text-[19px] grad-text whitespace-nowrap">🎯 HabitPoint</a>
          <nav className="hidden md:flex items-center gap-6 ml-6 text-[15px] font-semibold text-muted">
            <a href="#how" className="hover:text-ink">怎么用</a>
            <a href="#features" className="hover:text-ink">功能</a>
            <a href="#scenes" className="hover:text-ink">适用场景</a>
            <a href="#mechanism" className="hover:text-ink">核心机制</a>
          </nav>
          <div className="flex-1" />
          <Link href="/session/new" className="text-[15px] font-semibold text-muted hover:text-brand px-3 py-2">登录</Link>
          <Link href="/registration/new" className="text-[15px] font-bold text-white grad-bg px-4 py-2 rounded-xl hover:opacity-90">免费开始</Link>
        </div>
      </header>

      {/* ============ Hero ============ */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 hero-glow" />
        <div className="relative max-w-[1080px] mx-auto px-5 pt-16 pb-20 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block bg-[#eef2ff] text-brand font-bold px-3 py-1.5 rounded-full text-[13px] mb-5">
              🎁 把「该做的事」变成「想做的事」
            </span>
            <h1 className="text-[40px] md:text-[52px] leading-[1.1] font-extrabold tracking-tight">
              设目标 · 拆步骤<br />
              <span className="grad-text">完成得分 · 积分兑换</span>
            </h1>
            <p className="mt-6 text-[17px] text-muted leading-relaxed max-w-[480px]">
              一套用积分驱动的习惯养成系统。给自己立目标、给孩子定任务，
              每完成一步就得分，攒够积分兑换心仪奖励——坚持，从此有即时反馈。
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link href="/registration/new" className="text-white grad-bg font-bold px-6 py-3.5 rounded-xl text-[16px] hover:opacity-90 shadow-lg shadow-brand/25">
                免费开始 →
              </Link>
              <a href="#how" className="bg-white border border-[#e7ebf2] font-bold px-6 py-3.5 rounded-xl text-[16px] hover:border-brand">
                看看怎么用
              </a>
            </div>
            <p className="mt-4 text-[13px] text-muted">无需信用卡 · 支持个人与多孩子家庭</p>
          </div>

          {/* Hero 视觉：仿看板卡片 */}
          <div className="relative">
            <div className="bg-white rounded-3xl card-shadow border border-[#e7ebf2] p-5">
              <div className="flex items-center gap-2 mb-4">
                <span className="font-extrabold grad-text">🎯 HabitPoint</span>
                <div className="flex-1" />
                <span className="bg-[#eef2ff] text-brand font-bold px-3 py-1 rounded-full text-[13px]">💰 1,240 分</span>
              </div>
              <div className="grid grid-cols-3 gap-3 mb-4">
                <div className="bg-[#f4f6fb] rounded-xl p-3"><div className="text-2xl font-extrabold">17</div><div className="text-[12px] text-muted">连续打卡天</div></div>
                <div className="bg-[#f4f6fb] rounded-xl p-3"><div className="text-2xl font-extrabold">86</div><div className="text-[12px] text-muted">本月得分</div></div>
                <div className="bg-[#f4f6fb] rounded-xl p-3"><div className="text-2xl font-extrabold">5</div><div className="text-[12px] text-muted">进行中目标</div></div>
              </div>
              {/* 迷你趋势 */}
              <div className="bg-[#f4f6fb] rounded-xl p-3 mb-4">
                <div className="text-[12px] text-muted mb-2">近 30 天趋势</div>
                <svg viewBox="0 0 280 60" className="w-full h-14">
                  <polyline fill="none" stroke="#5b7cfa" strokeWidth="2.5"
                    points="0,45 28,40 56,42 84,30 112,33 140,22 168,26 196,15 224,18 252,8 280,12" />
                  <polyline fill="url(#g)" stroke="none"
                    points="0,45 28,40 56,42 84,30 112,33 140,22 168,26 196,15 224,18 252,8 280,12 280,60 0,60" />
                  <defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0" stopColor="#5b7cfa" stopOpacity=".25" /><stop offset="1" stopColor="#5b7cfa" stopOpacity="0" />
                  </linearGradient></defs>
                </svg>
              </div>
              {/* 今日打卡 */}
              <div className="space-y-2">
                <div className="flex items-center gap-3 bg-[#f4f6fb] rounded-xl px-3 py-2.5">
                  <span className="text-lg">🏃</span><span className="font-semibold text-[14px]">晨跑 20 分钟</span>
                  <div className="flex-1" /><span className="text-[12px] text-muted">+10</span>
                  <span className="text-white bg-[#1d7a44] text-[12px] font-bold px-2.5 py-1 rounded-lg">✓ 已完成</span>
                </div>
                <div className="flex items-center gap-3 bg-[#f4f6fb] rounded-xl px-3 py-2.5">
                  <span className="text-lg">📖</span><span className="font-semibold text-[14px]">阅读 30 页</span>
                  <div className="flex-1" /><span className="text-[12px] text-muted">+8</span>
                  <span className="text-brand border border-brand text-[12px] font-bold px-2.5 py-1 rounded-lg">打卡</span>
                </div>
              </div>
            </div>
            <div className="absolute -bottom-5 -left-5 bg-white rounded-2xl card-shadow border border-[#e7ebf2] px-4 py-3 hidden md:flex items-center gap-2">
              <span className="text-xl">🏅</span><span className="font-bold text-[14px]">解锁成就：连续 7 天</span>
            </div>
          </div>
        </div>
      </section>

      {/* ============ 痛点 / 价值 ============ */}
      <section className="max-w-[1080px] mx-auto px-5 py-6">
        <div className="grid md:grid-cols-3 gap-4">
          <div className="bg-white rounded-2xl border border-[#e7ebf2] card-shadow p-6">
            <div className="text-2xl mb-2">😮‍💨</div>
            <h3 className="font-bold text-[16px] mb-1">坚持没反馈，容易放弃</h3>
            <p className="text-[14px] text-muted leading-relaxed">把目标拆成可打卡的小步骤，每一步都立刻得分，看得见进度。</p>
          </div>
          <div className="bg-white rounded-2xl border border-[#e7ebf2] card-shadow p-6">
            <div className="text-2xl mb-2">🧒</div>
            <h3 className="font-bold text-[16px] mb-1">催孩子做事，吼到没电</h3>
            <p className="text-[14px] text-muted leading-relaxed">用积分代替唠叨：完成任务赚分，攒分换奖励，规则透明孩子认。</p>
          </div>
          <div className="bg-white rounded-2xl border border-[#e7ebf2] card-shadow p-6">
            <div className="text-2xl mb-2">🧾</div>
            <h3 className="font-bold text-[16px] mb-1">奖励发放说不清</h3>
            <p className="text-[14px] text-muted leading-relaxed">一切加分 / 兑换都进流水，余额由流水推导，可追溯、可撤销。</p>
          </div>
        </div>
      </section>

      {/* ============ 怎么用：4 步 ============ */}
      <section id="how" className="max-w-[1080px] mx-auto px-5 py-16">
        <div className="text-center mb-12">
          <h2 className="text-[32px] font-extrabold">四步，把习惯跑起来</h2>
          <p className="mt-3 text-muted text-[16px]">一个闭环，越用越上瘾</p>
        </div>
        <div className="grid md:grid-cols-4 gap-4">
          <div className="bg-white rounded-2xl border border-[#e7ebf2] card-shadow p-6 relative">
            <div className="w-10 h-10 grid place-items-center rounded-xl grad-bg text-white font-extrabold mb-4">1</div>
            <div className="text-3xl mb-2">🎯</div>
            <h3 className="font-bold text-[17px] mb-1">设目标</h3>
            <p className="text-[14px] text-muted leading-relaxed">比如「每天运动」「读完一本书」。</p>
          </div>
          <div className="bg-white rounded-2xl border border-[#e7ebf2] card-shadow p-6">
            <div className="w-10 h-10 grid place-items-center rounded-xl grad-bg text-white font-extrabold mb-4">2</div>
            <div className="text-3xl mb-2">🧩</div>
            <h3 className="font-bold text-[17px] mb-1">拆步骤</h3>
            <p className="text-[14px] text-muted leading-relaxed">把目标拆成可打卡的小步骤，自由设定积分。</p>
          </div>
          <div className="bg-white rounded-2xl border border-[#e7ebf2] card-shadow p-6">
            <div className="w-10 h-10 grid place-items-center rounded-xl grad-bg text-white font-extrabold mb-4">3</div>
            <div className="text-3xl mb-2">✅</div>
            <h3 className="font-bold text-[17px] mb-1">完成得分</h3>
            <p className="text-[14px] text-muted leading-relaxed">每日一键打卡，连击与达成自动记录。</p>
          </div>
          <div className="bg-white rounded-2xl border border-[#e7ebf2] card-shadow p-6">
            <div className="w-10 h-10 grid place-items-center rounded-xl grad-bg text-white font-extrabold mb-4">4</div>
            <div className="text-3xl mb-2">🛍️</div>
            <h3 className="font-bold text-[17px] mb-1">积分兑换</h3>
            <p className="text-[14px] text-muted leading-relaxed">攒够积分，在商店兑换自定义奖励。</p>
          </div>
        </div>
      </section>

      {/* ============ 功能特性 ============ */}
      <section id="features" className="bg-white border-y border-[#e7ebf2]">
        <div className="max-w-[1080px] mx-auto px-5 py-16">
          <div className="text-center mb-12">
            <h2 className="text-[32px] font-extrabold">一个 App，<span className="grad-text">七个页面</span>覆盖全流程</h2>
            <p className="mt-3 text-muted text-[16px]">从立目标到拿奖励，每一环都顺手</p>
          </div>
          <div className="grid md:grid-cols-3 gap-4">
            <div className="rounded-2xl border border-[#e7ebf2] p-6 hover:border-brand transition">
              <div className="text-2xl mb-2">📊</div><h3 className="font-bold text-[16px] mb-1">看板</h3>
              <p className="text-[14px] text-muted leading-relaxed">统计卡 + 近 30 天趋势 + 13 周热力图 + 多人排行榜。</p>
            </div>
            <div className="rounded-2xl border border-[#e7ebf2] p-6 hover:border-brand transition">
              <div className="text-2xl mb-2">✅</div><h3 className="font-bold text-[16px] mb-1">打卡</h3>
              <p className="text-[14px] text-muted leading-relaxed">今日步骤一键完成，打错可撤销，连击自动回滚。</p>
            </div>
            <div className="rounded-2xl border border-[#e7ebf2] p-6 hover:border-brand transition">
              <div className="text-2xl mb-2">🎯</div><h3 className="font-bold text-[16px] mb-1">目标</h3>
              <p className="text-[14px] text-muted leading-relaxed">列表 → 详情，加步骤、看完成预测、随时调整。</p>
            </div>
            <div className="rounded-2xl border border-[#e7ebf2] p-6 hover:border-brand transition">
              <div className="text-2xl mb-2">🛍️</div><h3 className="font-bold text-[16px] mb-1">商店</h3>
              <p className="text-[14px] text-muted leading-relaxed">自定义奖励，积分一键兑换。</p>
            </div>
            <div className="rounded-2xl border border-[#e7ebf2] p-6 hover:border-brand transition">
              <div className="text-2xl mb-2">🏅</div><h3 className="font-bold text-[16px] mb-1">成就</h3>
              <p className="text-[14px] text-muted leading-relaxed">8 个徽章：连续打卡 / 累计积分 / 完成目标。</p>
            </div>
            <div className="rounded-2xl border border-[#e7ebf2] p-6 hover:border-brand transition">
              <div className="text-2xl mb-2">📒</div><h3 className="font-bold text-[16px] mb-1">流水</h3>
              <p className="text-[14px] text-muted leading-relaxed">全部加分 / 兑换 / 撤销记录，一笔不漏。</p>
            </div>
          </div>
        </div>
      </section>

      {/* ============ 适用场景 ============ */}
      <section id="scenes" className="max-w-[1080px] mx-auto px-5 py-16">
        <div className="text-center mb-12">
          <h2 className="text-[32px] font-extrabold">一个人用，一家人用</h2>
        </div>
        <div className="grid md:grid-cols-2 gap-5">
          <div className="rounded-3xl grad-bg text-white p-8 card-shadow">
            <div className="text-3xl mb-3">🧑‍💻</div>
            <h3 className="text-[22px] font-extrabold mb-2">个人自我激励</h3>
            <p className="text-white/85 leading-relaxed">运动、阅读、早睡、学习……给自己设目标，用积分和连击对抗拖延，把长期主义变成每天看得见的小胜利。</p>
          </div>
          <div className="rounded-3xl bg-white border border-[#e7ebf2] p-8 card-shadow">
            <div className="text-3xl mb-3">👨‍👩‍👧‍👦</div>
            <h3 className="text-[22px] font-extrabold mb-2">亲子 / 家庭（可多孩子）</h3>
            <p className="text-muted leading-relaxed">每个成员数据独立，头部一键切换。家长拥有成员，可按 <b className="text-ink">只读 / 可写</b> 分享给另一位家长共同管理。用积分代替催促，规则透明。</p>
          </div>
        </div>
      </section>

      {/* ============ 核心机制 ============ */}
      <section id="mechanism" className="bg-white border-y border-[#e7ebf2]">
        <div className="max-w-[1080px] mx-auto px-5 py-16 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block bg-[#eef2ff] text-brand font-bold px-3 py-1.5 rounded-full text-[13px] mb-4">🧾 可追溯 · 可撤销</span>
            <h2 className="text-[30px] font-extrabold leading-tight mb-4">每一分，<span className="grad-text">都查得到来路</span></h2>
            <p className="text-muted text-[16px] leading-relaxed mb-4">
              所有积分变动都记成一条流水，余额完全由流水推导而来。
              打错卡、发错奖励？一键撤销，连带的连击与达成自动回滚——账永远是对的。
            </p>
            <ul className="space-y-2 text-[15px]">
              <li className="flex gap-2"><span className="text-brand font-bold">✓</span> 加分 / 兑换 / 撤销，全部留痕</li>
              <li className="flex gap-2"><span className="text-brand font-bold">✓</span> 余额由流水推导，不会对不上</li>
              <li className="flex gap-2"><span className="text-brand font-bold">✓</span> 多成员数据隔离，权限可控</li>
            </ul>
          </div>
          <div className="bg-[#f4f6fb] rounded-3xl border border-[#e7ebf2] p-5">
            <div className="text-[13px] text-muted font-semibold mb-3 px-1">📒 积分流水</div>
            <div className="space-y-2">
              <div className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 border border-[#e7ebf2]">
                <span className="text-lg">🏃</span><div><div className="font-semibold text-[14px]">完成「晨跑 20 分钟」</div><div className="text-[12px] text-muted">今天 08:12</div></div>
                <div className="flex-1" /><span className="text-[#1d7a44] font-bold">+10</span>
              </div>
              <div className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 border border-[#e7ebf2]">
                <span className="text-lg">🎮</span><div><div className="font-semibold text-[14px]">兑换「周末游戏 1 小时」</div><div className="text-[12px] text-muted">昨天 20:30</div></div>
                <div className="flex-1" /><span className="text-[#c0392b] font-bold">−50</span>
              </div>
              <div className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 border border-[#e7ebf2] opacity-60">
                <span className="text-lg">↩️</span><div><div className="font-semibold text-[14px] line-through">撤销「阅读 30 页」</div><div className="text-[12px] text-muted">昨天 19:05</div></div>
                <div className="flex-1" /><span className="text-muted font-bold">−8</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============ 结尾 CTA ============ */}
      <section className="max-w-[1080px] mx-auto px-5 py-20 text-center">
        <h2 className="text-[34px] md:text-[40px] font-extrabold">今天，就从第一个目标开始</h2>
        <p className="mt-4 text-muted text-[17px]">免费注册，注册即创建你的第一个成员。</p>
        <div className="mt-8 flex justify-center gap-3 flex-wrap">
          <Link href="/registration/new" className="text-white grad-bg font-bold px-8 py-4 rounded-xl text-[17px] hover:opacity-90 shadow-lg shadow-brand/25">免费开始 →</Link>
          <Link href="/session/new" className="bg-white border border-[#e7ebf2] font-bold px-8 py-4 rounded-xl text-[17px] hover:border-brand">我已有账号</Link>
        </div>
      </section>

      {/* ============ 页脚 ============ */}
      <footer className="border-t border-[#e7ebf2] bg-white">
        <div className="max-w-[1080px] mx-auto px-5 py-8 flex flex-wrap items-center gap-3 text-[14px] text-muted">
          <span className="font-extrabold grad-text">🎯 HabitPoint</span>
          <span>· 习惯积分</span>
          <div className="flex-1" />
          <a href="#how" className="hover:text-ink">怎么用</a>
          <a href="#features" className="hover:text-ink">功能</a>
          <Link href="/session/new" className="hover:text-ink">登录</Link>
        </div>
      </footer>
    </div>
  )
}
